
(function () {
  "use strict";

  var params = new URLSearchParams(window.location.search);
  var branch = params.get("branch");
  var staff = params.get("staff");

  var branchKey = "piliani_holiday_branch";
  var staffKey = "piliani_holiday_staff";

  // Save referral details from the unique link.
  try {
    if (branch) {
      localStorage.setItem(branchKey, branch);

      if (staff) {
        localStorage.setItem(staffKey, staff);
      } else {
        localStorage.removeItem(staffKey);
      }
    }
  } catch (e) {
    console.warn("Could not save referral details.");
  }

  // Restore saved referral details.
  var savedBranch;
  var savedStaff;

  try {
    savedBranch = localStorage.getItem(branchKey);
    savedStaff = localStorage.getItem(staffKey);
  } catch (e) {}

  if (!savedBranch) return;

  var attributes = {
    "Holiday Sets Branch": savedBranch,
    "Holiday Sets Staff": savedStaff || "Not specified"
  };

  var root = window.Shopify && window.Shopify.routes
    ? window.Shopify.routes.root
    : "/";

  fetch(root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      attributes: attributes
    })
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error("Unable to save referral attributes.");
      }
      return response.json();
    })
    .then(function (cart) {
      console.log("Holiday Sets referral saved:", cart.attributes);
    })
    .catch(function (error) {
      console.error("Referral tracking error:", error);
    });
})();
